// extracted by mini-css-extract-plugin
export default {"container":"Cc96AGK2"};